import { render, staticRenderFns } from "./SingleItemTest.vue?vue&type=template&id=458799fe&scoped=true&"
import script from "./SingleItemTest.vue?vue&type=script&lang=js&"
export * from "./SingleItemTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458799fe",
  null
  
)

export default component.exports